import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit'

import { API_STATUS } from '../types';
import type { RootState } from '../../app/store'

import { ACTION_TYPE_PARENT, fetchOrganizations } from './actions';
import { organizationSliceInitialState } from './types';


const INITIAL_STATE: organizationSliceInitialState = {
  organizationList: [],
  status: API_STATUS.idle,
  isLoading: false,
  error: null
}

/* eslint-disable no-param-reassign */
export const organizationSlice = createSlice({
  name: ACTION_TYPE_PARENT,
  initialState: INITIAL_STATE,
  reducers: {}
})
/* eslint-disable no-param-reassign */

// export const { } = organizationSlice.actions

export default organizationSlice.reducer;

export const selectedAllOrganizations = (state: RootState) => state[ACTION_TYPE_PARENT].organizationList